import { StandaloneAuth } from '@leagueplatform/auth-standalone';

/**
 * Acquires a token scoped to a specific tenant's organization and audience.
 *
 * Auth0 caches tokens per (audience, organization) combination — once a tenant
 * token has been acquired in a session, subsequent calls return instantly from
 * cache until expiry.
 *
 * @param audience - The Auth0 API audience for the tenant
 * @param organization - The Auth0 organization ID for the tenant
 * @returns The access token string
 */
export async function getTokenForTenant(
  audience: string,
  organization: string,
): Promise<string> {
  try {
    return await StandaloneAuth.client.getTokenSilently({
      audience,
      organization,
    });
  } catch (err) {
    throw err instanceof Error
      ? err
      : new Error('Failed to acquire tenant token.');
  }
}
